import React from 'react';

export default class MailForm extends React.Component {
    render() {
        return <div className="container emailform">
            <div className="row card-panel">
                <span style={{fontFamily:"AWLogo"}}>ASIA WEEKLY</span>'s quarterly <span style={{color:"#e51c23"}}><strong>Red-Letter Projects</strong></span> try to push the limits of what's possible in online multimedia journalism. Enter your email address to be notified of our next project. You will not receive other advertising. 
                <form className="col s12" action="//chinadailyasia.us13.list-manage.com/subscribe/post?u=f3716ee61624d714bc7c9a627&amp;id=f07cb81a08" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form">
                    <div className="row">
                        <div className="input-field col s12">
                            <input id="mce-EMAIL" type="email" className="validate" name="EMAIL" />
                            <label htmlFor="mce-email" data-error="Invalid email" data-success="right" style={{pointerEvents:"none",width:"100%"}}>Email</label>
                            <input type="submit" value="Submit" name="subscribe" id="mc-embedded-subscribe" className="btn inset-text" style={{float:"right"}} />
                        </div>
                    </div>
                </form>
            </div>
        </div>    
    }
}



/*<form action="//chinadailyasia.us13.list-manage.com/subscribe/post?u=f3716ee61624d714bc7c9a627&amp;id=f07cb81a08" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>

    <div class="mc-field-group">
        <label for="mce-EMAIL">Email Address </label>
        <input type="email" value="" name="EMAIL" className="required email" id="mce-EMAIL">
    </div>
    <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
</form>

<div className="container">
    <div className="row">
        <form className="col s12" action="//chinadailyasia.us13.list-manage.com/subscribe/post?u=f3716ee61624d714bc7c9a627&amp;id=f07cb81a08" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form">
            <div className="row">
                <div className="input-field col s12">
                    <input id="mce-EMAIL" type="email" className="validate" name="EMAIL">
                    <label for="mce-email" data-error="wrong" data-success="right">Email</label>
                </div>
            </div>
        </form>
    </div>
</div>*/


// WEBPACK FOOTER //
// ./src/js/components/MailForm/MailForm.jsx